import React, { Component } from 'react';
import InputPlaceholder from '../InputPlaceholder/InputPlaceholder';
import { filterReduxFormInput } from '../../core/util/form';
import { analyticsTrackEvent } from '../../core/analytics';
import { isEmptyObject } from '../../core/util/object';

export const displayErrors = (field: any, showErrors: any, touched: any, submitted: any) =>
  (submitted || touched || field.touched) && field.error && showErrors;

type OwnProps = {
  field: any;
  s: any;
  id: string;
  label?: string;
  placeholder?: string;
  trackEvent?: string;
  type?: string;
  inlineElements?: boolean;
  submitted?: boolean;
  submitting?: boolean;
  className?: string;
  errorOnTop?: boolean;
  autoFocus?: boolean;
  maxLength?: string;
  onBlur?: (...args: any[]) => any;
  showErrors?: boolean;
  sensitive?: boolean;
  errorInline?: boolean;
  funPlaceholder?: boolean;
  placeholderContainerName?: string;
  inputProps?: any;
};

type State = any;

type Props = OwnProps & typeof TextInput.defaultProps;

class TextInput extends Component<Props, State> {
  static defaultProps = {
    type: 'text',
    autoFocus: false,
    showErrors: true,
    funPlaceholder: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      touched: false,
    };
  }

  handleOnBlur = (e: any) => {
    this.setState({ touched: true });
    this.props.field.onBlur(e);
    if (this.props.trackEvent) {
      const properties = { name: this.props.id };
      analyticsTrackEvent(this.props.trackEvent, properties);
    }

    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(e);
    }
  };

  render() {
    const { touched } = this.state;
    const { errorInline, field, submitted, showErrors } = this.props;
    const inputValues = !isEmptyObject(this.props.inputProps)
      ? this.props.inputProps
      : filterReduxFormInput(this.props.field);

    return (
      <div
        className={
          displayErrors(field, errorInline, touched, submitted)
            ? this.props.s.formFieldInlineError
            : this.props.s.formField
        }
      >
        {this.props.errorOnTop && displayErrors(field, showErrors, touched, submitted) && (
          <div className={this.props.s.formFieldError}>{this.props.field.error}</div>
        )}

        {this.props.label && <label htmlFor={this.props.id}>{this.props.label}</label>}

        <div className={this.props.className || this.props.s.formInputContainer}>
          {this.props.funPlaceholder && this.props.placeholder && (
            <InputPlaceholder
              asLabel={!this.props.label}
              containerName={this.props.placeholderContainerName}
              field={this.props.field}
              focusId={this.props.id}
              placeholder={this.props.placeholder}
            />
          )}

          <input
            type={this.props.type}
            {...inputValues}
            aria-label={
              !this.props.label && !this.props.funPlaceholder ? this.props.placeholder : ''
            }
            autoFocus={this.props.autoFocus}
            className={this.props.sensitive ? 'inspectletIgnore' : ''}
            id={this.props.id}
            maxLength={this.props.maxLength}
            onBlur={this.handleOnBlur}
            placeholder={this.props.funPlaceholder ? '' : this.props.placeholder}
          />
          {this.props.inlineElements && this.props.submitted && (
            <img alt="Check Mark" src="/images/icons/check_mark_small.svg" />
          )}
          {this.props.inlineElements && !this.props.submitted && (
            <input
              autoFocus={this.props.autoFocus}
              className={
                this.props.sensitive
                  ? `inspectletIgnore ${this.props.s.inlineSubmit}`
                  : this.props.s.inlineSubmit
              }
              disabled={this.props.submitting}
              type="submit"
              value="Submit"
            />
          )}
        </div>
        {!this.props.errorOnTop && displayErrors(field, showErrors, touched, submitted) && (
          <div className={this.props.s.formFieldError}>{this.props.field.error}</div>
        )}
      </div>
    );
  }
}

export default TextInput;
